import { trimmedStringFromUnknown } from "../protocol/shared.js";
import { openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import { coreReadinessFactsChangedSchema } from "../protocol/core-readiness-facts-changed.js";
import { signalReplyToSchema } from "../protocol/signal-reply-to.js";
import { runtimeTransportStopCauseSchema } from "../daemon/runtime-transport-stop-cause.js";
import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/signal-system-notice.ts
const signalSystemNoticeTypeSchema = z$1.enum([
	"stay_silent",
	"policy_blocked",
	"terminal_failure",
	"wake_stopped",
	"execution_recovery_available",
	"execution_recovery_completed"
]);
const signalSystemNoticeGeneratedBySchema = z$1.literal("openmeld");
const signalSystemNoticeFailureStageSchema = z$1.enum(["execution", "publication"]);
const signalSystemNoticeDataSchema = z$1.strictObject({
	noticeType: signalSystemNoticeTypeSchema,
	actorProfileId: openMeldRuntimeProfileIdSchema.optional(),
	actorName: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	dispatchId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	resultRef: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	recoveryOperationId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	coreReadinessFactsChanged: coreReadinessFactsChangedSchema.optional(),
	replyTo: signalReplyToSchema.optional(),
	reason: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	reasonCode: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	failureStage: signalSystemNoticeFailureStageSchema.optional(),
	stopCause: runtimeTransportStopCauseSchema.optional(),
	text: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	generatedBy: signalSystemNoticeGeneratedBySchema
});
const signalSystemNoticeSchema = z$1.strictObject({
	type: z$1.literal("signal.system_notice"),
	data: signalSystemNoticeDataSchema
});
//#endregion
export { signalSystemNoticeDataSchema, signalSystemNoticeFailureStageSchema, signalSystemNoticeGeneratedBySchema, signalSystemNoticeSchema, signalSystemNoticeTypeSchema };

//# sourceMappingURL=signal-system-notice.js.map